import { Box, Typography } from "@mui/material"
import { IconSeeker, TooltipSeeker } from "@ui-seeker/core"
import React from "react"
import { truncateString } from "@utils"

export default function PopoverTitle({ carDescription, onClose }) {


	return <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'default' }}>
		<TooltipSeeker title={carDescription?.length > 20 && carDescription}>
			<Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: .5 }}>
				<IconSeeker icon="car" sx={{ color: 'primary.main', ml: .5, fontSize: "1rem" }}/>
				<Typography
					sx={{ fontWeight: 'bold' }}>{!!carDescription && truncateString(carDescription, 20)}
				</Typography>
			</Box>
		</TooltipSeeker>
		<Box
			data-tour-id="tour-popover-close"
			sx={{ color: "text.disabled", ml: 3, cursor: 'pointer' }}
			onClick={e => { e.stopPropagation(); onClose() }}
		>
			<IconSeeker icon="times" />
		</Box>
	</Box>
}